/**
 * resolveMarketingBrandConfig.js — picks the marketing chrome config for this host.
 * Shaped by: md3c step 4b.
 * Invariants: isMd3cMarketingHost() selects the md3c config. Every other host,
 * including fusionmsi.com, keeps getFusionMsiBrandConfig().
 * Related: fusionMsiBrandConfig.js, md3cBrandConfig.js,
 * FusionMsiMarketingLayout.jsx, FusionMsiMarketingNav.jsx.
 */
import { isMd3cMarketingHost } from 'features/md3c/marketing/md3cMarketingRouting';
import { MD3C_BRAND_CONFIG } from 'features/md3c/marketing/md3cBrandConfig';
import { getFusionMsiBrandConfig } from './fusionMsiBrandConfig';

export function resolveMarketingBrandConfig() {
  if (isMd3cMarketingHost()) return MD3C_BRAND_CONFIG;
  return getFusionMsiBrandConfig();
}
